/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import mapValues from 'lodash/mapValues';
import axios from 'axios';
import * as globals from '../constants/globals';
import {
    FETCH_AI_REVIEW_FAILURE,
    FETCH_AI_REVIEW_START,
    FETCH_AI_REVIEW_SUCCESS,
} from '../constants/types';
import { generateErrorMessage } from '../utils/error';
import { fetchAIReviewRequest } from '../model/publicReview';

export const fetchAIReviewEndpoint = (request: fetchAIReviewRequest) => {
    const encoded = mapValues(request, encodeURIComponent);
    return `${globals.API_URL}/location/${encoded.locationType}/${encoded.locationId}/summary`;
};

const fetchAIReviewApi = (request: fetchAIReviewRequest) => () =>
    axios.get(fetchAIReviewEndpoint(request), { headers: {}, timeout: 15_000 });

export function fetchAIReview(request: fetchAIReviewRequest) {
    return async (dispatch: Function) => {
        dispatch({
            type: FETCH_AI_REVIEW_START,
            payload: {
                location_id: request.locationId,
                location_type: request.locationType,
            },
        });

        try {
            const response = await dispatch(fetchAIReviewApi(request));
            const responseData = response.data;

            dispatch({
                type: FETCH_AI_REVIEW_SUCCESS,
                payload: {
                    data: responseData,
                },
            });

            return responseData;
        } catch (error) {
            const message = generateErrorMessage(error);
            dispatch({
                type: FETCH_AI_REVIEW_FAILURE,
                payload: {
                    error: message,
                },
            });
            throw new Error(message);
        }
    };
}
